export default __webpack_public_path__ + "static/media/element-bg-right.9d9c5dbc.png";